// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./node_modules/extract-text-webpack-plugin/dist/loader.js??ref--10-0!./node_modules/vue-style-loader!./node_modules/css-loader??ref--10-2!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/lib??ref--10-3!./node_modules/sass-loader/dist/cjs.js??ref--10-4!./node_modules/vue-loader/lib??vue-loader-options!./src/components/shared/elements/modal/Modal.vue?vue&type=style&index=0&id=b19422c6&lang=scss&scoped=true&
// module id = WHy0
// module chunks = 33